import useDataResetPwd from './useDataResetPwd'
import { TbAlertCircle as AlertIcon } from 'react-icons/tb'
import Button from '../../components/ui/Button'

const ResetPwd = () => {
	const { loadingResetPassword, values, errors, touched, handleChange, handleSubmit, handleBlur } =
		useDataResetPwd()

	return (
		<div>
			<p className="text-dark mb-6 text-3xl font-semibold text-[#343a40]">Recovery</p>

			<form onSubmit={handleSubmit}>
				<div className="form-group mb-4">
					<label htmlFor='email'>Enter email</label>
					<input
						type="email"
						name="email"
						className="form-control"
						placeholder="Email"
						onChange={handleChange}
						onBlur={handleBlur}
						value={values.email}
						required
					/>
					<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
						{errors.email && touched.email && (
							<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
						)}
						{errors.email && touched.email && (
							<div className="text-sm text-red-600" role="alert">
								<span className="font-medium">{errors.email}</span>
							</div>
						)}
					</div>
				</div>

				<Button
					type="submit"
					variant="primary"
					className="mt-4 w-full"
					loading={loadingResetPassword}
				>
					Reset password
				</Button>
			</form>
		</div>
	)
}
export default ResetPwd
